export type WorkflowEditorSelection = {
  readonly selectedNodeIds: readonly string[];
  readonly selectedEdgeIds: readonly string[];
};

export const EMPTY_WORKFLOW_EDITOR_SELECTION: WorkflowEditorSelection = {
  selectedNodeIds: [],
  selectedEdgeIds: [],
};

export type WorkflowToolbarState = {
  readonly connectFromNodeId: string | undefined;
  readonly expanded: boolean;
};
